import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/del.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0f030d03")

_pushScopeId("data-v-0f030d03")
const _hoisted_1 = { class: "bg-ff content" }
const _hoisted_2 = { class: "flex alignC mar-b-30 mar-l-30" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { class: "padding-30" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { style: {} }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "flex flexR mar-t-12 bold" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, "总金额：", -1)
const _hoisted_14 = { class: "flex flexC alignC mar-t-22" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "提交", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_17 = { class: "dialog-content" }
const _hoisted_18 = { class: "flex dialog-screen" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_20 = { class: "flex flexC form-button" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "立即创建", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "c-60 w-500" }, "取 消", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")
  const _component_editList = _resolveComponent("editList")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      (_ctx.navindex == 1 || _ctx.navindex == 3 || _ctx.navindex == 4)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.formRules,
              inline: true,
              "label-width": "120px",
              class: "width-900"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, { label: "单据日期" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.date,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.date = $event)),
                        type: "date",
                        "value-format": "x",
                        onChange: _ctx.selectDate,
                        placeholder: "选择日期"
                      }, null, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "采购员",
                    prop: "employee_id"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.employee_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.employee_id = $event)),
                        filterable: "",
                        placeholder: "请选择",
                        class: "width-211"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PurchaseManList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.nickname,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_el_form_item, {
                    label: "供应商",
                    prop: "supplier_id"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.supplier_id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.supplier_id = $event)),
                        filterable: "",
                        placeholder: "请选择",
                        class: "width-211"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.supplierList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.supplier_name,
                              value: item.supplier_id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "实际采购单号" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        class: "width-211",
                        modelValue: _ctx.form.purchase_sh,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.purchase_sh = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_el_form_item, { label: "备注" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        style: {"width":"600px"},
                        modelValue: _ctx.form.purchase_desc,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.purchase_desc = $event)),
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_editList, {
        partsData: _ctx.form.parts,
        show_add: true,
        onBtn_add: _ctx._editlist_add
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "配件名称",
            width: "250"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_7, [
                _createVNode("img", {
                  onClick: ($event: any) => (_ctx._defItem(scope.$index)),
                  src: _imports_0,
                  class: "wh-24"
                }, null, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "mar-l-16",
                  style: {"width":"160px"}
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "规格",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_8, _toDisplayString(scope.row.specification), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "配件分类",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_9, _toDisplayString(scope.row.mountings_type_p_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "品牌",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_10, _toDisplayString(scope.row.mountings_brand_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_11, _toDisplayString(scope.row.mountings_unit_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "采购单价",
            "min-width": "125",
            align: "center"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_autocomplete, {
                class: "inline-input",
                modelValue: scope.row.unit_price,
                "onUpdate:modelValue": ($event: any) => (scope.row.unit_price = $event),
                "fetch-suggestions": ((queryString, cb)=>{_ctx.querySearch(queryString, cb,scope.row.mountings_id)}),
                placeholder: "请输入内容",
                "hide-loading": "true",
                onSelect: _ctx.priceSelect
              }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "数量",
            "min-width": "125",
            align: "center"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.number,
                "onUpdate:modelValue": ($event: any) => (scope.row.number = $event),
                type: "text",
                class: "mar-l-16",
                onInput: _ctx.calTotalPrice,
                style: {"width":"80px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["partsData", "onBtn_add"]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("div", null, _toDisplayString(_ctx.totalPrice), 1)
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx._onsubmit
        }, {
          default: _withId(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withId(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_dialog, {
        center: "",
        title: "添加配件",
        modelValue: _ctx.dialog_show.parts,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialog_show.parts = $event)),
        width: 900
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_17, [
            _withDirectives(_createVNode("div", null, [
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_el_input, {
                  style: {"width":"302px"},
                  modelValue: _ctx.dialogSelect.search,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogSelect.search = $event)),
                  placeholder: "项目名称/编码/拼音首字母",
                  clearable: "",
                  class: "mar-r-18",
                  "suffix-icon": "el-icon-search",
                  onChange: _ctx.getOrderMountings
                }, null, 8, ["modelValue", "onChange"]),
                _createVNode(_component_el_button, {
                  class: "mar-l-12",
                  onClick: _ctx.getOrderMountings
                }, {
                  default: _withId(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_el_table, {
                data: _ctx.partsTable,
                stripe: "",
                style: {"width":"100%"},
                class: "table",
                "header-cell-style": _ctx.headClass,
                "highlight-current-row": _ctx.is_all,
                onCurrentChange: _ctx.handleCurrentChange,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withId(() => [
                  (_ctx.is_all)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        type: "selection",
                        width: "55"
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "header-cell-style", "highlight-current-row", "onCurrentChange", "onSelectionChange"])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 0]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_form, {
                "label-width": "100px",
                model: _ctx.partsForm,
                rules: _ctx.partsRules,
                ref: "partsFormNode"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "配件名称",
                    prop: "name"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.name,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.partsForm.name = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "规格",
                    prop: "specification"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.specification,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.partsForm.specification = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "编码",
                    prop: "encoding"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.encoding,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.partsForm.encoding = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "销售价",
                    prop: "price"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.price,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.partsForm.price = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "单位",
                    prop: "unit_id"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        class: "mar-r-18",
                        modelValue: _ctx.partsForm.unit_id,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.partsForm.unit_id = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_unit_data, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "返现方案",
                    prop: "return_cash_plan"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        class: "mar-r-18",
                        modelValue: _ctx.partsForm.return_cash_plan,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.partsForm.return_cash_plan = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.reappearance_type_data, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_el_button, {
                  class: "bg-red",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addService(false)))
                }, {
                  default: _withId(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.partsDialog = false))
                }, {
                  default: _withId(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 1]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 512), [
      [_directive_loading, _ctx.is_load]
    ])
  ]))
})